import React, { useState, useEffect } from 'react';

import {
    Text,
    Input,
    Textarea,
    HStack,
    Spacer,
    Divider,
    VStack,
} from '@chakra-ui/react';

import Const from '../Constants';

import EpicSelector from '../Atoms/EpicSelector';
import HighLowSelector from '../Atoms/HighLowSelector';
import AgentTaskRunner from './AgentTaskRunner';
import { useTasksStore } from '../Stores/TasksStore';
import { useAgentsStore } from '../Stores/AgentsStore';

const TaskDetails = ({ auth, mode, currentTask, setCurrentTask, setAppMode }) => {
    const handleUpdateTask_ = useTasksStore((state) => state.handleUpdateTask_);
    const loadAgents = useAgentsStore((state) => state.loadAgents);

    useEffect(() => {
        loadAgents(auth);
    // eslint-disable-next-line
    }, []);

    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [title, setTitle] = useState(currentTask ? currentTask.title : '');
    
    const [isEditingDescription, setIsEditingDescription] = useState(false);
    const [description, setDescription] = useState(currentTask ? currentTask.description : '');

    useEffect(() => {
        if(currentTask) {
            currentTask.title = title;
        }
        
        if(mode === Const.sTaskDetailsBar) {
            setCurrentTask(currentTask);
        }
    // eslint-disable-next-line
    }, [title]);

    useEffect(() => {
        if(currentTask) {
            currentTask.description = description;
        }
        if(mode === Const.sTaskDetailsBar) {
            setCurrentTask(currentTask);
        }
    // eslint-disable-next-line
    }, [description]);

    // When user selects another task
    useEffect(() => {
        if(currentTask) {
            setTitle(currentTask.title);
            setDescription(currentTask.description);
        }
    }, [currentTask]);

    const handleBlurTitle = () => {
        setIsEditingTitle(false);

        handleUpdateTask_(auth, currentTask.id, currentTask.title);
    };

    const handleBlurDescription = () => {
        setIsEditingDescription(false);

        handleUpdateTask_(auth, currentTask.id, null, currentTask.description);
    };

    return (
        <VStack alignItems={'left'} spacing={2} h={mode === Const.sTaskDetailsBar ? '100%' : 'auto'}>
        { // Title
            isEditingTitle ? (
                <Input
                    autoFocus
                    
                    color={Const.White}
                    fontSize={Const.XL}
                    fontWeight={Const.Bold}
                    marginTop={'8px'}
                    value={title}
                    onChange={(event) => {
                        setTitle(event.target.value);
                    }}
                    onBlur={handleBlurTitle}
                    onKeyDown={(event) => {
                      if (event.key === Const.sEnter) {
                          handleBlurTitle();
                          event.preventDefault(); // Prevents any default action
                      }
                  }}
              />
            ) : (
                <Text
                    color={Const.White}
                    fontSize={Const.XL}
                    fontWeight={Const.Bold}
                    align={Const.Left}
                    marginTop={'8px'}
                    _hover={{ cursor: 'text' }}
                    onClick={() => {
                        setIsEditingTitle(true);
                    }}
                >
                    {title}
                </Text>
            )
        }

        <HStack>
            <Text
                fontSize={Const.SM}
                fontWeight={Const.Bold}
                align={Const.Left}
                color={Const.Gray165}
            >
                Epic
            </Text>

            <Spacer />
            
            <EpicSelector
                currentEpicId={currentTask ? currentTask.epicId : null}
                onChange={(newEpicId) => {
                    handleUpdateTask_(auth, currentTask.id, null, null, null, null, null, newEpicId);
                }}
            />
        </HStack>

        <Divider my={4} borderColor={Const.Gray100}/>

        {
        // Importance and Urgency
        <>
        <HStack>
            <Text
                fontSize={Const.SM}
                fontWeight={Const.Bold}
                align={Const.Left}
                color={Const.Gray165}
            >
                Importance
            </Text>

            <Spacer />

            <HighLowSelector
                value={currentTask ? currentTask.importance : null}
                onChange={(newValue) => {
                    handleUpdateTask_(auth, currentTask.id, null, null, null, null, null, null, newValue);
                } } />

        </HStack>

        <HStack>
            <Text
                fontSize={Const.SM}
                fontWeight={Const.Bold}
                align={Const.Left}
                color={Const.Gray165}
            >
                Urgency
            </Text>

            <Spacer />

            <HighLowSelector
                value={currentTask ? currentTask.urgency : null}
                onChange={(newValue) => {
                    handleUpdateTask_(auth, currentTask.id, null, null, null, null, null, null, null, newValue);
                } } />

        </HStack>
        </>
        }

        <AgentTaskRunner
            auth={auth}
            task={currentTask}
            setAppMode={setAppMode}
            onAssign={(agentId) => {
                console.log('agentId', agentId);
                
                handleUpdateTask_(auth, currentTask.id, null, null, null, null, null, null, null, null,
                    agentId ? 'agent' : null, agentId || null);
                }
            }
        />

        <Divider my={4} borderColor={Const.Gray100}/>

        <Text
                fontSize={Const.SM}
                fontWeight={Const.Bold}
                align={Const.Left}
                color={Const.Gray165}
            >
                Description
            </Text>
        
        { // Description
            <Textarea
                value={description}
                color={Const.White}
                autoFocus={isEditingDescription}
                fontSize={Const.MD}
                resize={Const.sNone}
                flex={mode === Const.sTaskDetailsBar ? 1 : undefined}
                minH={mode === Const.sTaskDetailsBar ? 0 : '200px'}
                overflowY='auto'
                marginTop={'6px'}
                padding={isEditingDescription ? '6px' : '0px'} // Remove padding when not editing
                readOnly={!isEditingDescription} // Make it readOnly when not in editing mode
                placeholder={'Enter the description here'}
                _placeholder={{ color: Const.Gray100 }}  // Setting placeholder text color
                border={isEditingDescription ? '1px solid' : Const.sNone} // Show border only when editing
                onBlur={handleBlurDescription}
                onChange={(event) => {
                    setDescription(event.target.value);
                }}
                onClick={() => {
                    if (!isEditingDescription) setIsEditingDescription(true);
                }}
                _hover={{
                    cursor: 'text'
                }}              
          />
        }
    </VStack>
    );
};

export default TaskDetails;
